import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { VolunteerSpecialistPool } from '@interfaces';
import { AppService, DomainDataService } from '../../../../../../services';
import { VolunteeringAreaService } from '../../../../volunteering-area.service';


export function getColumns(util: UtilityService, domainData: DomainDataService, app: AppService, service: VolunteeringAreaService) {

	const columns: GridColumn<VolunteerSpecialistPool, unknown>[] = [
		buildColumn(util, 'Id', row => row.assignedToStaffId, { header: 'assignedToStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.assignedToStaffId), { header: 'Assigned Staff', width: 120 }),
		buildColumn(util, 'Id', row => row.lastContactStaffId, { header: 'lastContactStaffId', hidden: true }),
		buildColumn(util, 'FullName', row => app.getStaffNameById(row.lastContactStaffId), { header: 'Last Contacted By', width: 120 }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastContactUTC), { header: 'Last Contact Date', width: 80 }),
		buildColumn(util, 'Id', row => row.volunteerId),
		buildColumn(util, 'FullName', row => row.person.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => domainData.data().volunteerStatusesMap[row.volunteerStatusId]?.name, {
			header: 'Status',
			filter: { operator: FilterOperator.Contains, value: 'Approved' }
		}), buildColumn(util, 'Number', row => row.countOfApprovedTopcis, { header: 'Topics', headerTooltip: 'Number of Approved Topics', width: 80 }),
		buildColumn(util, 'Text', row => row.agreementsSigned, { header: 'Agreements', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => row.attendedOrientation, { header: 'Attended Orientation', width: 80, hidden: true }),
		buildColumn(util, 'YesNo', row => !!row.interviewDateUTC, { header: 'Interviewed', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEnVideo ? 'Added' : 'Missing', { header: 'English Video', width: 80, hidden: true }),
		buildColumn(util, 'Text', row => row.hasEsVideo ? 'Added' : 'Missing', { header: 'Spanish Video', width: 80, hidden: true }),
		buildColumn(util, 'Percent', row => row.interviewScore, { header: 'Interview Score', width: 30, hidden: true }),
		buildColumn(util, 'Number', row => row.signUpsCount.currentTrimester, { header: `${service.selectedTrimesterName()} Sign-ups`, headerTooltip: `Total Sign-ups for ${service.selectedTrimesterName()}`, width: 80 }),
	];

	if (service.volunteeringData()?.selectedNextTrimester?.trimesterId) {
		columns.push(
			buildColumn(util, 'Number', row => row.signUpsCount.nextTrimester, { header: `${service.selectedNextTrimesterName()} Sign-ups`, headerTooltip: `Total Sign-ups for ${service.selectedNextTrimesterName()}` }),
		)
	}

	return columns;

}
